import React from 'react';
import GafferToggle from '../../../components/GafferToggle';

/**
 * The Beat The Gaffer decision, as a setup step in both wizards.
 *
 * It gets its own step rather than a line on the review panel because it changes who
 * is in the competition — and because the prize-money warning deserves to be read
 * rather than skimmed past on the way to the submit button. Off by default: nobody
 * ends up with an extra rival in their game by not noticing a checkbox.
 */
function GafferStep({ checked, onChange, intro }) {
  return (
    <>
      <p className="helper-text wizard-intro">{intro}</p>
      <GafferToggle checked={checked} onChange={onChange} />
    </>
  );
}

export default GafferStep;
